import React, {forwardRef} from 'react';
import classNames from 'classnames';
import {InputMask} from 'primereact/inputmask';

const MaskedInput = forwardRef((props, ref) => {
    const {
        variant = 'site', // site | admin
        className = '',
        mask,
        message,
        ...rest
    } = props;

    const classes = classNames(`formInput`, `formInput--${variant}`, className, {
        'error': message,
    });

    return (
        <InputMask
            ref={ref}
            className={classes}
            mask={mask}
            message={message}
            {...rest}
        />
    );
});

export default MaskedInput;
